import React from 'react';
import { TABLE_TYPE_MONTHLY_PIVOT } from '../../../../Helper/BatteryHealth/SohHistoryHelper';
import SohMonthlyHistory from './SohMonthlyHistory/SohMonthlyHistory';

// Table-type dispatch for the Monthly history view (tables.MonthlyHistory.type).
// Only types listed here can render it; resolveMonthlyHistoryConfig's
// showSwitch hides the switch for any other type.
export const MONTHLY_HISTORY_VIEWS = {
    [TABLE_TYPE_MONTHLY_PIVOT]: SohMonthlyHistory,
};

/** The component for a table type, or null when the type cannot render the view. */
export const getMonthlyHistoryView = (type) => MONTHLY_HISTORY_VIEWS[type] || null;

const MonthlyHistoryView = ({ monthlyConfig, ...props }) => {
    const View = getMonthlyHistoryView(monthlyConfig?.type);
    return View ? <View monthlyConfig={monthlyConfig} {...props} /> : null;
};

export default MonthlyHistoryView;
